import siFetch from "api/fetch";

const self = (init = null) => siFetch("/api/v1/campaign/my", init);

export default self;
